module.exports = __webpack_public_path__ + "img/ad01.3b1e1823.png";